export var DefinitionPropertyNameInJson;
(function (DefinitionPropertyNameInJson) {
    DefinitionPropertyNameInJson["searchTermDefinition"] = "search_term_definitions";
})(DefinitionPropertyNameInJson || (DefinitionPropertyNameInJson = {}));
